export default __webpack_public_path__ + "static/media/footer-flying-yogi.925457f0.jpg";